/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';

type NextButtonProps = {
  /** Disables the button. */
  disabled: boolean;
  /** Called on click. */
  onClick: () => void;
};

const Styles = {
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

/**
 * Renders the button to advance to the next form stage.
 */
const NextButton = ({ disabled = false, onClick }: NextButtonProps) => (
  <div css={Styles.root}>
    <Button isDisabled={disabled} onPress={onClick}>
      Next
    </Button>
  </div>
);

export default NextButton;
